
webpack.register(
    'modules/right-rail/what-we-do-for-golf/what-we-do-for-golf',
    function() {
        return import('modules/right-rail/what-we-do-for-golf/what-we-do-for-golf');
    },
    true
);